import { makeAutoObservable, runInAction } from "mobx";
import {
  PropertiesService,
} from "../services/PropertiesService";
import type { Imovel } from "../scripts/db";

export class PropertyStore {
  selectedProperty: Imovel | null = null;
  featuredProperties: Imovel[] = [];
  isLoading = false;
  error: string | null = null;

  private service = new PropertiesService();

  constructor() {
    makeAutoObservable(this);
  }

  async loadByCode(code: string): Promise<void> {
    this.isLoading = true;
    this.error = null;
    try {
      const result = await this.service.getByCode(code);
      runInAction(() => {
        this.selectedProperty = result;
        this.isLoading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.error = err instanceof Error ? err.message : "Failed to load property";
        this.isLoading = false;
      });
    }
  }

  async loadFeatured(): Promise<void> {
    this.isLoading = true;
    this.error = null;
    try {
      const result = await this.service.getFeatured();
      runInAction(() => {
        this.featuredProperties = result;
        this.isLoading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.error = err instanceof Error ? err.message : "Failed to load featured";
        this.isLoading = false;
      });
    }
  }

  clearSelected(): void {
    this.selectedProperty = null;
  }
}
